import { IAuthState } from '../../../../../services/auth/models';
import * as React from 'react';
import { flow, isEmpty, map } from 'lodash';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { isUndefined } from 'util';
import { Button, Col, ControlLabel, Form, FormGroup, Modal } from 'react-bootstrap';
import FieldFormControl from '../../../../../components/FieldFormControl';
import FaSpinner from 'react-icons/fa/spinner';
import { translatePasswordError } from '../../../../../util/helpers';

interface IUpdateEmailFormProps {
  auth: IAuthState;
  onCloseModal: any;
  handleSubmit: any;
  dispatch: any;
  change: any;
  isSaved: boolean;
  isSubmitting: boolean;
  email: string;
  phone1: string;
  password: string;
}

interface IUpdateEmailFormState {
  openModal: boolean;
  canSave: boolean;
  activeField?: string;
}

class UpdateEmailForm extends React.Component<IUpdateEmailFormProps, IUpdateEmailFormState> {
  public state = {
    openModal: false,
    canSave: false,
    activeField: null,
  };

  public componentWillReceiveProps(nextProps: IUpdateEmailFormProps) {
    const updatedFields = (!isUndefined(nextProps.password) && nextProps.password.length > 0)
      && ((!isUndefined(nextProps.email) && nextProps.email.length > 0)
      || (!isUndefined(nextProps.phone1) && nextProps.phone1.length > 0));

    if (this.state.canSave !== updatedFields) {
      this.setState({
        canSave: updatedFields,
      });
    }
  }

  public render() {
    const {
      isSaved,
      onCloseModal,
      handleSubmit,
      auth,
    } = this.props;

    return(
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <Modal.Body>
          {isSaved && (
            <div>
              {auth && auth.error && ! isEmpty(auth.error.update) ? (
                <div className="alert alert-danger" style={{marginTop: '10px'}}>
                  {map(auth.error.update, (error, key) => {
                    return <p key={key}>{error.detail}</p>;
                  })}
                </div>
              ) : (
                <p>Your changes have been taken into account.</p>
              )}
            </div>
          )}
          {!isSaved && (
            <div>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Re-enter Password:
                </Col>
                <Col sm={9}>
                  <Field
                    id="password"
                    name="password"
                    type="Password"
                    component={FieldFormControl}
                    placeholder="Password"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Email:
                </Col>
                <Col sm={9}>
                  <Field
                    name={'email'}
                    component={FieldFormControl}
                    clearable={'false'}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Telephone:
                </Col>
                <Col sm={9}>
                  <Field
                    name={'phone1'}
                    component={FieldFormControl}
                    clearable={'false'}
                  />
                </Col>
              </FormGroup>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <div>
              {(this.state.canSave && !this.props.isSaved) && (
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={this.props.isSubmitting}
                >
                  {this.props.isSubmitting && (
                    <FaSpinner className="fa-spin"/>
                  )}
                  <span>Save</span>
                </Button>
              )}

              {!this.props.isSubmitting && (
                <Button
                  bsStyle="primary"
                  onClick={onCloseModal}
                  disabled={this.props.isSubmitting}
                >
                  {this.props.isSaved ? 'Close' : 'Cancel'}
                </Button>
              )}
            </div>
          </div>
        </Modal.Footer>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'customer2',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('customer2');

    return component;
  },
  connect(
    (state: IStore) => {
      const email = selector(state, 'email');
      const phone1 = selector(state, 'phone1');
      const password = selector(state, 'password');

      return {
        email,
        phone1,
        password,
        auth: state.auth,
        quote: state.quote,
      };
    },
  ),
])(UpdateEmailForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/UpdateEmailModal/UpdateEmailModalForm/index.tsx